import script from "./CreateApp.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateApp.vue?vue&type=script&setup=true&lang=js"

import "./CreateApp.vue?vue&type=style&index=0&id=4ed6a542&lang=scss&scoped=true"
import "./CreateApp.vue?vue&type=style&index=1&id=4ed6a542&lang=scss"

import exportComponent from "/home/nicolas-choquet/www/play-private-store/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed6a542"]])

export default __exports__